import React, { CSSProperties, useEffect } from 'react';
import styles from './UpgradeBanner.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUserContactCount } from '@actions/user';
import { useOnVisible } from '@support/hooks/use-on-visible';
import { useAuthContext } from '@hooks/use-auth-context';
import { MessageButton } from '@components/ViewMessage';
import { ProBadge } from '@components/Icons/ProductNameBadge';
import { selectUserContactCount } from '@reducers/user/stats';
import upgradeAction from '@support/upgrade-action';

const appSumoLimit = 5000;

export default function UpgradeBanner() {
  const dispatch = useDispatch();
  const { user, contactLimit, getIsFreePlan } = useAuthContext();
  const contactLimitString = contactLimit?.toLocaleString();
  const userContactCount = useSelector(selectUserContactCount);
  const proportionUsed = userContactCount && contactLimit ? userContactCount / contactLimit : 0;

  let copy = `You're currently managing ${userContactCount.toLocaleString()} of ${contactLimitString} available relationships.`;
  if (userContactCount > contactLimit) {
    copy = `You're currently managing all of your ${
      contactLimitString ? contactLimitString + ' ' : ''
    }available relationships.`;
  }

  if (contactLimit === appSumoLimit) {
    copy += ' Upgrade to remove this limit.';
  }

  const onClick = upgradeAction(user, dispatch);

  useOnVisible(() => {
    dispatch(fetchUserContactCount());
  }, []);

  useEffect(() => {
    dispatch(fetchUserContactCount());
  }, []);

  if (!contactLimit || proportionUsed < 0.8 || !getIsFreePlan()) {
    return null;
  }

  return (
    <>
      <div className={styles.spacer} />
      <div className={styles.upgradeBanner}>
        {contactLimit !== appSumoLimit && (
          <div className={styles.title}>
            <h3>Upgrade to Clay</h3>
            <ProBadge />
          </div>
        )}
        <p>{copy}</p>
        {/* @ts-ignore: custom data attr */}
        <div
          className={styles.progressBar}
          style={
            {
              '--bar-progress': `translateX(${Math.floor(Math.min(1, proportionUsed) * 100)}%)`,
            } as CSSProperties
          }
        />
        <MessageButton
          button={{
            text: 'Upgrade',
            onClick,
          }}
        />
      </div>
    </>
  );
}
